import './charts.css';

/**
 * Suspense-fallback voor de lazy chart-componenten.
 *
 * Bewust exact hetzelfde element als de root van elke chart: een lege
 * `<div className="chart-canvas"/>`. Die class draagt alle layout (flex 1 1 0,
 * min-height 160px / 280px op mobile, width 100%), dus de placeholder neemt
 * precies dezelfde ruimte in als de grafiek erna. Geen spinner, geen tekst,
 * geen border — anders verspringt of flitst de layout tijdens het laden.
 */
export function ChartPlaceholder() {
  return <div className="chart-canvas" aria-hidden="true" />;
}
